"use client";
import { Box, Link, Table } from "@chakra-ui/react";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";

export type SupportFeature = {
  docsText: string;
  docsLink: string;
  docsText2?: string;
  docsLink2?: string;
};

const OneMindSupportTable = (props: SupportFeature) => {
  const { docsText, docsLink, docsText2, docsLink2 } = props;
  const HeadingVariant = useHeadingVariant();

  return (
    <Box borderWidth="1px" borderRadius="lg" p={6} mt={8}>
      <Heading variant={HeadingVariant} mb={4}>
        OneMind Support
      </Heading>
      <Table.Root>
        <Table.Header bg="gray.50" _dark={{ bg: "gray.700" }}>
          <Table.Row>
            <Table.ColumnHeader>Support Feature</Table.ColumnHeader>
            <Table.ColumnHeader>Description</Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell fontWeight="semibold">Email Support</Table.Cell>
            <Table.Cell>
              <Link
                href={"mailto:support@onemindservices.com"}
                color="primary.200"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@onemindservices.com
              </Link>
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell fontWeight="semibold">Docs & Repository</Table.Cell>
            <Table.Cell>
              <Link
                href={docsLink}
                color="primary.200"
                target="_blank"
                rel="noopener noreferrer"
              >
                {docsText}
              </Link>
              {docsText2 && (
                <Link
                  href={docsLink2}
                  color="primary.200"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  , {docsText2}
                </Link>
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell fontWeight="semibold">Report Issues</Table.Cell>
            <Table.Cell>
              Security or behavior concerns?{" "}
              <Link
                href={"mailto:support@onemindservices.com"}
                color="primary.200"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@onemindservices.com
              </Link>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

export default OneMindSupportTable;
